import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-modal-resumen-activity',
    templateUrl: './modal-resumen-activity.component.html',
    styleUrls: ['./modal-resumen-activity.component.scss'],
    standalone: false
})
export class ModalResumenActivityComponent implements OnInit {

    constructor(public activeModal: NgbActiveModal) { }

    ngOnInit() {
    }

    closeModal() {
        this.activeModal.close();
    }

}
